import { ResetPasswordForm } from './dumb.js';
import enhance from './enhancer';

export default enhance(ResetPasswordForm);
